import Vue from 'vue'
import Vuex from 'vuex'
import Cookie from 'vue-cookies';

import common from '@/common/common.js'

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        langcur: common.basic.chstr2int(Cookie.get('lang'), 1),
        langdic: common.json.sync('/include/dic2.json'),
        config: common.json.sync('/include/config.json'),
        logourl: '',
        face: '',
        username: '',
        showname: '',
        topnav: 1,
        isfull: false,
        topnavsort: 1,
        islogin: common.basic.chstr2int(Cookie.get('islogin')),
        memlev: common.basic.chstr2int(Cookie.get('memlev')),
        wh: window.innerHeight,// document.body.clientHeight;
        ww: window.innerWidth,// document.body.clientWidth;
        tctitle: '韬客学院'
    },
    getters: {
        isstu: state => state.memlev == 1,
        istea: state => state.memlev == 2,
        issmall: state => state.ww <= 600,
        tctype: state => state.config.tctype || 0,
        tctitlereal: state => state.config.tctype == 1 ? '戴尔特商学院' : state.config.tctype == 2 ? '泰尔弗商学院' : state.tctitle
    },
    mutations: {
        SET_ISLOGIN(state, v) {
            if (state.islogin != v) {
                state.islogin = v;
                Cookie.set('islogin', v, -1);
            }
        },
        SET_MEMLEV(state, v) {
            if (state.memlev != v) {
                state.memlev = v;
                Cookie.set('memlev', v, -1);
            }
        },
        SET_LANGCUR(state, v) {
            if (state.langcur != v) {
                state.langcur = v;
                Cookie.set('lang', v, -1);
            }
        },
        SET_LOGOURL(state, v) {
            if (state.logourl != v) {
                state.logourl = v;
            }
        },
        SET_USERNAME(state, v) {
            if (state.username != v) {
                state.username = v;
            }
        },
        SET_SHOWNAME(state, v) {
            if (state.showname != v) {
                state.showname = v;
            }
        },
        SET_FACE(state, v) {
            if (state.face != v) {
                state.face = v;
            }
        },

        SET_WINDOWSIZE(state) {
            state.wh = window.innerHeight;// document.body.clientHeight;
            state.ww = window.innerWidth;// document.body.clientWidth;
        },
        SET_TOPNAV(state, v) {
            if (state.topnav != v) {
                state.topnav = v;
                state.isfull = v >= 100;
                state.topnavsort = state.isfull ? v / 100 : v;
            }

        }
    },
    actions: {
        setislogin({ commit }, v) {
            commit('SET_ISLOGIN', v);
        },
        setmemlev({ commit }, v) {
            commit('SET_MEMLEV', v);
        },
        setlangcur({ commit }, v) {
            commit('SET_LANGCUR', v);
        },
        setlogourl({ commit }, v) {
            commit('SET_LOGOURL', v);
        },
        setusername({ commit }, v) {
            commit('SET_USERNAME', v);
        },
        setshowname({ commit }, v) {
            commit('SET_SHOWNAME', v);
        },
        setface({ commit }, v) {
            commit('SET_FACE', v);
        }
    }
});

export default store;
